import WeeklyActivity from './WeeklyActivity';

export default WeeklyActivity;
